import "../../styles/UserDashboard/SellEnergy.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import EnergyHeader from "../../components/energy/energyHeader";
import { useNavigate, useParams } from "react-router-dom";
import { usePaystackPayment } from "react-paystack";
import { useEffect, useState } from "react";
import EnergySharingContract from "../../Abi/EnergySharingContract.json";
import Web3 from "web3";
import { ethers } from "ethers";
import { useForm } from "react-hook-form";
import {EnergyTradingIntegration}  from "../../instantiateTransaction/EnergySharing";
import { lgaList } from "../../data/nigerianStatesData";
import {
  buyListedEnergy,
  getEnergyListedDetails,
} from "../../apis/energySharing";
import { useSelector } from "react-redux";
import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";
import useCountdown from "../../utils/useCountdown";
import DisputeModal from "../../components/energy/disputeModal";
import ChoosePaymentMethodModal from "../../components/energy/choosePaymentMethodModal";
import P2PAccountDetailsModal from "../../components/energy/p2pAccountDetailsModal";

export default function BuyEnergy() {
  const auth = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const [amount, setAmount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [account, setAccount] = useState(null);
  const [listing, setListing] = useState(null);
  const [values, setValues] = useState(null);
  const [web2Listing, setWeb2Listing] = useState(null);
  const [tradeInitiated, setTradeInitiated] = useState(false);
  const [transactionCompleted, setTransactionCompleted] = useState(false);
  const [open, setOpen] = useState(false);
  const pathname = useParams();
  const [loading, setLoading] = useState(false);
  const [tradeId, setTradeId] = useState("");
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [paymentOption, setPaymentOption] = useState("");
  const [transferOpen, setTransferOpen] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  const configPaystack = {
    // reference: (new Date()).getTime().toString(),
    email: auth?.userInfo?.email,
    amount: Number(amount) * Number(listing?.pricePerUnit) * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
    metadata: {
      firstName: auth?.userInfo?.firstName,
      lastName: auth?.userInfo?.lastName,
      email: auth?.userInfo?.email,
      phone: "08055553569",
    },
    publicKey: "pk_test_3f715236ee25c842649abc6a3c013258a37f9b1c",
    // publicKey: "pk_live_6a7e7c0b5677117392f596dff24695cbd0dd2eb0",
    text: "Pay Now",
  };

  const initializePayment = usePaystackPayment(configPaystack);

  const onSuccess = (response) => {
    console.log("response response", response);
    console.log("response?.reference", response?.reference);
    // handleVerifyDonation();
    handleCallBack(response?.reference);
  };

  const onClose = () => alert("Are you want to cancel this transaction");

useEffect(() => {
      if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => setAccount(accounts[0]))
        .catch((err) => {
          alert(
            "Please allow access to your MetaMask wallet to enable you exchange your CCRT"
          );
          console.error("User denied account access", err);
        });
    } else {
      console.error(
        "MetaMask is not installed. Please install it to use this app."
      );
    }
  }, []);

  // const contractAddress = "0xeb575bf85F0E888d962A0116db7c142235B8d3E2";
  const contractAddress = "0xb763ecF4323B5ce42c5D6a39Cc0E11c712fE104b";


  const contractABI = EnergySharingContract.abi;

  const contract = web3
    ? new web3.eth.Contract(contractABI, contractAddress)
    : null;

  const handleInitiateTrade = async () => {
    let tempTradeId;
    setLoading(true);

    if (!amount || !contract) {
      alert("Missing required data: amount or listing ID");
      setLoading(false);
      return;
    }

    try {
      const integration = new EnergyTradingIntegration("buyer");
      await integration.init();
      tempTradeId = await integration.initiateListingTrade(
        Number(pathname?.id),
        Number(amount)
      );
      setTradeId(tempTradeId);
      startCountdown(handleTimerComplete);
      setTradeInitiated(true);
      setPaymentOpen(true);
    } catch (error) {
      console.error("Failed to initiate listing trade:", error);
      alert(`Trade initiation failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(paymentOption === "paystack") {
      handleBuyListedEnergy();
    }else if(paymentOption === "bank transfer") {
      setTransferOpen(true);
    }
  }, [paymentOption]);

  const handleGetListing = async () => {
    const integration = new EnergyTradingIntegration("buyer");
    await integration.init();
    const response = await integration.getSellerListing(pathname?.id);
    const response2 = await getEnergyListedDetails(pathname?.id, auth?.token);

    console.log("getSellerListing", response);
    console.log("getEnergyListedDetails", response2);
    setListing(response);
    setWeb2Listing(response2?.data?.data);
  };

  useEffect(() => {
    handleGetListing();
  }, []);

  const states = Object.keys(lgaList).sort();

  const handleBuyListedEnergy = async () => {
    initializePayment(onSuccess, onClose);
  };
  const handleCallBack = async (transactionId) => {
    console.log({
      transactionId,
      tradeId
    });
    // const response = await buyListedEnergy(
    //   transactionId,
    //   web2Listing?.id,
    //   auth?.userInfo?.email,
    //   "paystack",
    //   amount,
    //   "sell",
    //   {
    //     min: listing?.minPurchaseAmount,
    //     max: listing?.maxPurchaseAmount
    //   },
    //   Number(amount) * Number(listing?.pricePerUnit),
    //   web2Listing?.sellerId,
    //   web2Listing?.state,
    //   web2Listing?.houseNumber,
    //   web2Listing?.address,
    //   auth?.userInfo?.id,
    //   tradeId,
    //   auth?.token
    // );

    // if (response?.data?.statusCode === 200) {
    //   setTransactionCompleted(true);
    //   alert("Transaction successful");
    // } else {
    //   alert("Something went wrong");
    // }

    // console.log("buyListedEnergy", response);
  };

  const onSubmit = (data) => {
    console.log("data", data);
    if (amount > listing?.maxPurchaseAmount) {
      alert("Amount entered is greater than seller limit");
    } else if (amount < listing?.minPurchaseAmount) {
      alert("Amount entered is lesser than seller limit");
    } else {
      setValues(data);
      handleInitiateTrade();
      // handleBuyListedEnergy();
    }
    // setStage(2);
  };

  const config = {
    public_key: "FLWPUBK-**************************-X",
    tx_ref: Date.now(),
    amount: 100,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: "user@gmail.com",
      phone_number: "070********",
      name: "john doe",
    },
    customizations: {
      title: "my Payment Title",
      description: "Payment for items in cart",
      logo: "https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  const { timeLeft, isActive, startCountdown, pauseCountdown, resetCountdown } =
    useCountdown(1800); // 30 minutes in seconds



  const handleCancelTrade = async () => { 
    if (!contract || !account) return;

    try {
      await contract.methods
        .cancelTrade(tradeId)
        .send({ from: account })
        .on("transactionHash", (hash) => {
          console.log("Transaction Hash:", hash);
        })
        .on("receipt", async (receipt) => {
          console.log("Receipt:", receipt);
        })
        .on("error", (error) => {
          console.error("Error:", error);
          return;
        });

        // Send user to dispute resolution page
    } catch (error) {
      console.error("Energy Listing Failed", error);
      setLoading(false);
    }
  }

  const handleTimerComplete = () => {
    console.log("Timer finished!");
    // Do something when the timer ends
    if (tradeInitiated && !transactionCompleted) {
      handleCancelTrade();
    }
    // alert("Time's up!");
  };

  return (
    <div className="sellEnergy">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="sellEnergy__inner">
        <EnergyHeader />

        <div className="sellEnergy__inner__card">
          <div className="sellEnergy__inner__card__header">
            <div className="sellEnergy__inner__card__header__user">
              <div className="sellEnergy__inner__card__header__user__icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                    stroke="#2C9963"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                    stroke="#2C9963"
                    stroke-width="2"
                  />
                </svg>
              </div>

              <div>
                <div className="sellEnergy__inner__card__header__user__title">
                  {listing?.location}
                </div>
                <div className="sellEnergy__inner__card__header__user__subtitle">
                  Location: <span>{listing?.location}</span>
                </div>
              </div>
            </div>

            <div className="sellEnergy__inner__card__header__timer">
              {formatTime(timeLeft)}
            </div>

            <div className="sellEnergy__inner__card__header__rate"
            onClick={() => setOpen(true)}
            >
              ₦{listing?.pricePerUnit} / kWh
            </div>
          </div>

          <form
            className="sellEnergy__inner__card__cards"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="sellEnergy__inner__card__cards__card1">
              <label
                className="sellEnergy__inner__card__cards__label"
                htmlFor="
                "
              >
                Amount to buy
              </label>
              <div className="sellEnergy__inner__card__cards__card1__input">
                <div>kWh</div>
                <input
                  type="number"
                  placeholder="0.00"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <div
                  className="pointer"
                  onClick={() => setAmount(listing?.maxPurchaseAmount)}
                >
                  Max
                </div>
              </div>

              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Buyer wants</div>
                <div>{amount || 0} kWh</div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Seller limit</div>
                <div>
                  {listing?.minPurchaseAmount} - {listing?.maxPurchaseAmount}{" "}
                  kWh
                </div>
              </div>
              <div className="sellEnergy__inner__card__cards__card1__info">
                <div>Buyer will pay</div>
                <div>₦{Number(amount) * Number(listing?.pricePerUnit)}</div>
              </div>
            </div>
            <div className="sellEnergy__inner__card__cards__card2">
              <div className="sellEnergy__inner__card__cards__card2__input-group">
                <div>
                  <label
                    className="sellEnergy__inner__card__cards__label"
                    htmlFor=""
                  >
                    State
                  </label>
                  <select name="" id="" {...register("stateOfOrigin")}>
                    <option value="">Choose state</option>
                    {states?.map((item) => (
                      <option value={item}>{item}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label
                    className="sellEnergy__inner__card__cards__label"
                    htmlFor=""
                  >
                    House Number
                  </label>
                  <input
                    type="text"
                    placeholder="House number"
                    {...register("houseNumber")}
                  />
                </div>
              </div>

              <label
                className="sellEnergy__inner__card__cards__label"
                htmlFor=""
              >
                Address
              </label>
              <input
                type="text"
                placeholder="Address"
                {...register("address")}
              />

              <div className="sellEnergy__inner__card__cards__card2__terms">
                <input type="checkbox" name="" id="" />
                <div>
                  I agree to the <a href="">Terms of Service</a>
                </div>
              </div>

              <button
                type="button"
                onClick={handleSubmit(onSubmit)}
                disabled={loading}
              >
                {loading ? "Loading..." : "Proceed to buy"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <DisputeModal open={open} setOpen={setOpen} />
      <ChoosePaymentMethodModal open={paymentOpen} setOpen={setPaymentOpen} setPaymentOption={setPaymentOption} />
      <P2PAccountDetailsModal open={transferOpen} setOpen={setTransferOpen} />
    </div>
  );
}
